export const childQuestions = [
  {
    id: 'reading_style',
    question: "How do you like to read?",
    options: ['I like pictures', 'I like listening', 'I like to read on my own', 'Other: ____']
  },
  {
    id: 'reading_time',
    question: "Do you take breaks when reading?",
    options: ['Yes', 'No', 'Sometimes!']
  },
  {
    id: 'reading_preferences',
    question: "What kind of stories do you like?",
    options: ['Animals', 'Funny', 'Magic/Adventure', 'Real Facts']
  },
  {
    id: 'reading_difficulties', /*Not sure what to name this, but its not like reading_challenges for parents */
    question: "Reading can feel tricky sometimes! Do any of these sound like you?",
    options: ['I get distracted/it’s hard to focus', 'Some words are hard to read', 'Pictures and audio help me understand better!', 'I’m not sure']
  }

  
];
